import interpolateValues from '@clearscore/helpers.interpolate-values';

const CONFIG_SUBSTRING = '{(.*)}';

const interpolateKey = (key, state, message) => {
    const { interpolated } = interpolateValues(state, { interpolated: key });
    return message.replace(`{${key}}`, interpolated);
};

export default (message, state) => {
    if (!message) throw new Error('Alert passed as configuration without a message');
    const keyFromMessage = message.match(new RegExp(CONFIG_SUBSTRING));
    return keyFromMessage ? interpolateKey(keyFromMessage[1], state, message) : message;
};
